import React, { useState, useEffect, useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../libraries/loader/loader";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
// import Button from 'react-bootstrap/Button'; getvendorcode
// import { getvendorcode, getBalanceFromServer, Fetchexternaldetails, Fetchexternaldetails,  Fetchexternaldetails, Fetchexternaldetails } from '../../../services/process/alcs/alcs_service';
import Modal from 'react-bootstrap/Modal';
import { getvendorcode, getBalanceFromServer,Fetchbankinvoicedetails1,Fetchexternaldetails, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetchbankinvoicedetails_1, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew, getdataforcardsrecon } from '../../../services/process/BRS1/brsService1';

import { Form, Input, Button, Grid, Checkbox } from 'semantic-ui-react';
import axios from 'axios';
import Select, { AriaOnFocus } from 'react-select';
import { baseUrl } from "../../../services/common/credentials";

import excelIcon from '../../../assets/images/excel.png';
import * as XLSX from 'xlsx';
// import './reports/reports.css';




var selectedOptionss;
var col_data = new Array();
const localhost_url = baseUrl + Fetchexternaldetails;

const CustomAriaLive = ({data})  => {
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [value, setValue] = useState(undefined);
  const onMenuOpen = () => setIsMenuOpen(true);
  const onMenuClose = () => setIsMenuOpen(false);
 
  const selectedOption = (e) =>{
    // selectedOption.pop();
    // selectedOptionss=[];
    selectedOptionss = e;
    console.log('clicked', e);
  }
  // const Options = [
  //   {value:"1", label:"anh"},
  //   {value:"2", label:"ank"},
  //   {value:"3", label:"an123"},
  //   {value:"4", label:"anhjhg"}
  // ]

  return (
    <form>
      <Select
        aria-labelledby="aria-label"
        inputId="aria-example-input"
        name="aria-live-color"
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        options={data}
        onChange={e => selectedOption(e)}
        
      />
    </form>
  );
}


function EmailsList() {
  // const [paginationSize] = useState(15);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [hideResultGrid, setHideResultGrid] = useState(true);
  const [rowData, setRowData] = useState(undefined);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formValues, setFormValues] = useState({ id: "", client_id: "", client_name: "",email_address: "" });
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  // const [filteredData, setFilteredData] = useState(undefined);
  // const [tenantId, settenantId] = useState(undefined);
  const [formCreate, setFormCreate] = useState(true);
  const [options, setOptions] = useState(undefined);
  const [options1, setOptions1] = useState(undefined);
  const [date, setDate] = useState(undefined);
  // const [checkbox, setCheckbox] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState({});
  const ref = useRef([]);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  
  const [rowData1, setRowData1] = useState([]);
  const [hideResultGrid1, setHideResultGrid1] = useState(true);
  const [clientids, setclientids] = useState([]);

  var gridColumns = [  
    
    { field: 'client_id', headerName: 'client_id', sortable: true, filter: true, resizable: true, width:110},
    { field: 'client_name', headerName: 'client_name', sortable: true, filter: true, resizable: true, width:400},
    { field: 'email_address', headerName: 'email_address', sortable: true, filter: true, resizable: true, width:300},
    { field: 'last_send_on', headerName: 'last_send_on', sortable: true, filter: true, resizable: true, width:205},
    
    { field: 'processed_date', headerName: 'processed_date', sortable: true, filter: true, resizable: true, width:200},
    
    
  ]




  const columns = [
    // { id: 'all', label: 'all', minWidth: 10 },
    { id: 'id', label: 'Sl.no', minWidth: 10 },
    { id: 'client_id', label: 'Vendor Code', minWidth: 10 },
    { id: 'client_name', label: 'Vendor Name', minWidth: 10 },
    { id: 'vendor_site_code', label: 'Vendor Site Code', minWidth: 10 },
    { id: 'contact_first_name', label: 'contact_first ame', minWidth: 10 },
    { id: 'vendor_site_code', label: 'Vendor Site Code', minWidth: 10 },
    {
      id: 'email_address',
      label: 'email address',
      minWidth: 10
    },
    {
      id: 'actions',
      label: 'actions',
      minWidth: 10
    },

  ];

  
  function getClientdata()
    {
        setLoaderOpen(true);
        let payload = {
          "tenants": userCredentials["tenants_id"],
          "groups": userCredentials["groups_id"],
          "entities": userCredentials["entities_id"],
          "mProcessingLayerId": userCredentials["m_processing_layer_id"],
          "mProcessingSubLayerId": userCredentials["m_processing_sub_layer_id"],
          "typeId": userCredentials["processing_layer_id"],
          'user_id': userCredentials['user_id']
        }
        console.log('userCredentials["groups_id"],', userCredentials);
        var getProcessingLayerList = getvendorcode();
        console.log("brs", getProcessingLayerList)
    
        axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
          .then(
            response => {
              console.log("Processing customer List vendor code!!!", response)
              
              let data = response["data"];
              
              console.log('data', data);
              if (data) {
                let options = data.map((row) => ({label:row.vendor_code, value:row.vendor_code}));
                let client_ids = data.map((row) => ({label:row.division, value:row.division, key:row.vendor_code}));
                // console.log('options', options);
                setOptions(options);
                setclientids(client_ids);
                setLoaderOpen(false);
                
              }
              setLoaderOpen(false);
            }
          ).catch(
            error => {
              console.log("Error in Processing Layer List!!!", error);
              setLoaderOpen(false);
            }
          );
    

        // var getclientdetails = getBalanceFromServer();

        // axios.post(getclientdetails[1], payload, getclientdetails[0])
        // .then(
        //     response => {
        //         console.log(" get client data Response!!!", response)
        //         let data = response["data"];
        //         // setRowData(data);
        //         console.log('data', data);
        //         let options = [{value:"ALL", label:"ALL"}];
        //         data.map(data =>{
        //           console.log('{value:"1", label:"anh"},{id: 1, client_id: "vgfd", client_name: "ramu"}', data);
        //           options.push({value:data.client_name, label:data.client_id})
        //         })
        //         console.log(options);
        //         setOptions(options)
        //         setLoaderOpen(false);
        //       }
        // ).catch(
        //     error => {
        //         console.log("Error in get client details!!!", error);
        //         setLoaderOpen(false);
        //     }
        // );

    }


  useEffect(() => {
    setLoaderOpen(false);
    // let url = `http://127.0.0.1:8002/api/v2/alcs/emails_list/`;
    // makeAPICall(url);
    getClientdata();
  }, []);

  // const makeAPICall = async (url) => {
  //   try {
  //     setLoaderOpen(true);
  //     console.log(url);
  //     const response = await fetch(url);
  //     const data = await response.json();
  //     // setRowData(data);
  //     console.log('data', data);
  //     let options = [{value:"ALL", label:"ALL"}];
  //     data.map(data =>{
  //       console.log('{value:"1", label:"anh"},{id: 1, client_id: "vgfd", client_name: "ramu"}', data);
  //       options.push({value:data.client_name, label:data.client_id})
  //     })
  //     console.log(options);
  //     setOptions(options)
  //     setLoaderOpen(false);
  //   }
  //   catch (e) {
  //     console.log(e);
  //     setLoaderOpen(false);
      
  //   }
  // }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EditActions = ({ row }) => {
    setFormCreate(false);
    setShow(true);
    setFormValues({ id: row.id, client_id: row.client_id, client_name:row.client_name, email_address: row.email_address });
  };

  
  const handleClose = () => {
    setFormValues({ id: "", client_id: "", client_name: "",email_address: "" });
    setShow(false);
    setShow1(false);
    setShow2(false);
    setShow3(false);
  };

  const handleChange = (e) => {
    
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    })
  }

  let handleSubmit = (event) => {
    event.preventDefault();
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.email_address)) {
      alert('Invalid email address')
    }else{
      let url;
	  
		let data = {
			'tenants_id': userCredentials["tenants_id"],
			'groups_id' : userCredentials["groups_id"],
			'entities_id': userCredentials["entities_id"],
			'user_id': userCredentials["user_id"],
			'client_id': formValues.client_id,
			'client_name': formValues.client_name,
			'email_address': formValues.email_address,
			'is_active': 'yes',
		}
	
      if (formCreate == true) {
        url = localhost_url+`/api/v2/alcs/createmail/`;
      } else {
        url = localhost_url+`/api/v2/alcs/updateemails/${formValues.id}/`;
      }
	  console.log('userCredentials["tenants_id"]', userCredentials["tenants_id"]);
	 
	  
      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then((result) => {
        result.json().then((resp) => {
          console.log(resp);
          if (formCreate == true) {
            setFormValues({ id: "", client_id: "", client_name: "",email_address: "" });
            setFormCreate(true);
            setShow(false); 
            setShow2(true);
			let value = selectedOptionss.label;
            console.log('selectedOptionss', selectedOptionss);
            let url =  localhost_url + `/api/v2/alcs/filteremails/${value}/`;
            makeAPICall1(url);
          }else{
          if (resp == 'updated successfully' || resp == 'created successfully') {
            setFormValues({ id: "", client_id: "", client_name: "",email_address: "" });
            setFormCreate(true);
            setShow(false); 
            let value = selectedOptionss.label;
            console.log('selectedOptionss', selectedOptionss);
            let url =  localhost_url + `/api/v2/alcs/filteremails/${value}/`;
            makeAPICall1(url);
          }
        }
        })
      })
    }
  }

  // const handleFilterChange = (value) => {
  //   settenantId(value);
  //   if (value) {
  //     let url = `http://127.0.0.1:8000/api/v2/user_modules/filteremails/${value}/`;
  //     makeAPICall(url);
  //   }
  // };

  const displayDialogbox = () =>{
    setFormValues({ id: '', client_id: selectedOptionss.label, client_name:selectedOptionss.value, email_address: '' });
	setFormCreate(true);
    setShow(true);
  }

  const makeAPICall1 = async (url) => {
    try {
      setLoaderOpen(true);
      console.log(url);
      const response = await fetch(url);
      const data = await response.json();
      setRowData(data);
      console.log('data', data);
      
      setHideResultGrid(false);
      setHideResultGrid1(true);
      setLoaderOpen(false);
    }
    catch (e) {
      console.log(e);
      
      setHideResultGrid1(true);
      setHideResultGrid(true);
	  setLoaderOpen(false);
    }
  }

  // const makeAPICall2 = () => {
  //   try {
  //     setLoaderOpen(true);
  //     // console.log(url);
  //     // const response = await fetch(url);
  //     // const data = await response.json();
  //     // setRowData(data);
  //     // console.log('data', data);
      
  //     setHideResultGrid(false);
  //     setHideResultGrid1(true);
  //     setLoaderOpen(false);
  //   }
  //   catch (e) {
  //     console.log(e);
      
  //     setHideResultGrid1(true);
  //     setHideResultGrid(true);
	//   setLoaderOpen(false);
  //   }
  // }

  const makeAPICall2 = () =>{
    let payload = {
      "tenants": userCredentials["tenants_id"],
      "groups": userCredentials["groups_id"],
      "entities": userCredentials["entities_id"],
      "mProcessingLayerId": userCredentials["m_processing_layer_id"],
      "mProcessingSubLayerId": userCredentials["m_processing_sub_layer_id"],
      "typeId": userCredentials["processing_layer_id"],
      'user_id': userCredentials['user_id']
    }
    console.log('userCredentials["groups_id"],', userCredentials);
    var getProcessingLayerList = getvendorcode();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let data = response["data"];
          
          console.log('data', data);
          setRowData(data);
          setLoaderOpen(true);
          setHideResultGrid(false);
          setHideResultGrid1(true);
          setLoaderOpen(false);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
          setLoaderOpen(false);
          setHideResultGrid1(true);
          setHideResultGrid(true);
        }
      );
    }



  
  function handleDropdownChange(event, item) {
    console.log('data' + event);
    
    if (event.target.checked == false) {
      // setCheckbox(false);
      // setSelectedColumns({});
      // col_data.remove(item);
      const index = col_data.indexOf(item);
      col_data.splice(index, 1);
    }
    else if (event.target.checked) {
      col_data.push(item);
      
    }
    console.log('123' + col_data);
  }


  const Unchecked = (event) => {
    
    if(event.target.checked == false){
    for (let i = 0; i < rowData.length; i++) {
        ref.current[i].checked = false;
    }
    rowData.map(data =>{
      col_data.push(data);
    })
  }else{
    for (let i = 0; i < rowData.length; i++) {
      ref.current[i].checked = true;
    }
    col_data = [];
  }
  }
  const DeleteEmails = () => {
    setShow1(true); 
  }

  const DeleteEmails1 = () => {
    console.log('col_data', col_data);
    col_data.map(id =>{
      axios.delete(localhost_url+`/api/v2/alcs/deletemails/${id}/`)
      .then(res => {
        console.log(res);
        console.log(res.data);
        let value = selectedOptionss.label;
		console.log('selectedOptionss', selectedOptionss);
		let url =  localhost_url + `/api/v2/alcs/filteremails/${value}/`;
		makeAPICall1(url);
      });
    })
    setShow1(false);
  }

  

	
  const displaySendEmail = () =>{
    setShow3(true);
  }
  
  function get_report() {
    setLoaderOpen(true);
    let payload = {
      "client_id": selectedOptionss.label,
      "report_date": date,
      'entities_id': userCredentials["entities_id"],
    }
    console.log('payload', payload);

    var getSingleMailSent = Fetchexternaldetails();

    axios.post(getSingleMailSent[1], payload, getSingleMailSent[0])
      .then(
        response => {
          console.log("fetch processed emails list", response)
          let data = response["data"];
          if (data && data.hasOwnProperty('Status') && data['Status'] == 'Error') {
            setHideResultGrid(true);
            setHideResultGrid1(true);
            setLoaderOpen(false);
          }
          else {
            setRowData1(data);
            setHideResultGrid1(false);
            setHideResultGrid(true);
            setLoaderOpen(false);
          }
          
        }
      ).catch(
        error => {
          console.log("Error in Fetching processed emails list", error);
          setLoaderOpen(false);
        }
      );

  }
  

  const handleSelection1 = (event) => {
    setSelectedOption1(event);
  }


  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
        var workBook = XLSX.utils.book_new();
        var workSheet = XLSX.utils.json_to_sheet(data, {
            skipHeader: false,
        });
        XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
        XLSX.writeFile(workBook, excelFileName);
        return true;
    }
    catch
    {
        return false;
    }
}

function exportToExcel() {
    let fileNameChange = "emailsReport.xlsx";
    let sheetName = "sheet";

    let excelExportData = [];

    for (let i = 0; i < rowData1.length; i++) {
        let data = {};
        for (let key in rowData1[i]) {
            for (let j = 0; j < gridColumns.length; j++) {
                if (key === gridColumns[j]["field"]) {
                    data[gridColumns[j]["headerName"]] = rowData1[i][key]
                }
            }
        }

        excelExportData.push(data);
    };

    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

}

  // const HandleSubmitEmail = () => {
  //   let data = [];

  //   rowData.map(data =>{
  //     data.push(data.email_address)
  //   })
  //   console.log('email submit');
  //   let url = `http://127.0.0.1:50010/api/v1/alcs/common/alcs_clent_mail_sent_revised/`;
  //     fetch(url, {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(data)
  //     }).then((result) => {
  //       result.json().then((resp) => {
  //       console.log(resp); 
  //       })
  //     })
  // }
  
  
  const deactivateEmailId = ({row}) => {
    // setLoaderOpen(true);
    let payload = {
      'id': row.id,
      'entities_id': userCredentials["entities_id"],
      'tenants_id': userCredentials["tenants_id"],
    }
    console.log('payload', payload);

    var getSingleMailSent = Fetchexternaldetails();

    axios.post(getSingleMailSent[1], payload, getSingleMailSent[0])
      .then(
        response => {
          console.log("fetch processed emails list", response);    
          
        }
      ).catch(
        error => {
          console.log("Error in Fetching processed emails list", error);
          // setLoaderOpen(false);
        }
      );
  }

  const activateEmailId = ({row}) => {
    // setLoaderOpen(true);
    let payload = {
      'id': row.id,
      'entities_id': userCredentials["entities_id"],
      'tenants_id': userCredentials["tenants_id"],
    }
    console.log('payload', payload);

    var getSingleMailSent = Fetchexternaldetails();

    axios.post(getSingleMailSent[1], payload, getSingleMailSent[0])
      .then(
        response => {
          console.log("fetch processed emails list", response);    
          
        }
      ).catch(
        error => {
          console.log("Error in Fetching processed emails list", error);
          // setLoaderOpen(false);
        }
      );
  }


  function handleSelection(event) {
    console.log('event', event);
    const selectedValue = event;

    // const selectedOption = options.find(option => option.processing_layer_name === selectedValue); // Find the option with the selected value
    // const layerId = selectedOption ? selectedOption.processing_layer_id : null; 
    // console.log("layerId", layerId);
    setSelectedOption(selectedValue);
    // setLayerId(layerId);
    // getBalances(layerId);
    // processingLayerData(selectedValue, layerId);

    const filterKey = selectedValue.label;
    console.log(filterKey);

    // Filter the data based on the specified key
    console.log(filterKey);
    const filteredData = clientids.filter(item => item.key === filterKey);
    console.log(filteredData);
    // Create a Set to track unique values
    const uniqueSet = new Set();

    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;

      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }

      return false; // Skip duplicates
    });

    console.log(filteredData1);

    console.log('filteredData', filteredData);
    setOptions1(filteredData1);

  }
  return (
    <>
      <div className="side" style={{ padding:"10px"}}>
     <Grid columns='equal'>
          <Grid.Row style={{ backgroundColor:"#fff",borderRadius:"12px",marginTop:"10px"}}>
          <Grid.Column>
          <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Vendor code</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={options}
                  selection
                  size='mini'
                  onChange={handleSelection}
                  value={selectedOption}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column >

          <div className="form-group ">
            <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Division</label> <br />
            <div className="reconsummary">
              <Select
                clearable
                options={options1}
                selection
                size='mini'
                onChange={handleSelection1}
                value={selectedOption1}

              />
            </div>
          </div>

          </Grid.Column>
          <Grid.Column style={{width:'12em'}}>
          <Button variant="contained" color="primary" type="button" onClick={makeAPICall2}>View</Button>
          </Grid.Column>
          <Grid.Column>
          <Button variant="contained" color="primary" type="button" onClick={displayDialogbox}>Add</Button>
          </Grid.Column>
		  <Grid.Column>
              <Button variant="contained" color="primary" type="button" onClick={get_report}>Get Report</Button>
           </Grid.Column>
          </Grid.Row> 
       
      <Button variant="contained" color="primary" type="button" style={{float:'right', marginTop:'1.2em'}} onClick={DeleteEmails} hidden={hideResultGrid}>Delete</Button>
          <Grid.Row style={{ backgroundColor:"#fff",borderRadius:"12px",marginTop:"2.3em"}} hidden={hideResultGrid}>
          <Paper sx={{ width: '97%', overflow: 'hidden',marginLeft:'1em'}}>
        <TableContainer sx={{ maxHeight: 260 }} style={{width:'102%', marginLeft:'-0.8em'}}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow style={{ backgroundColor: 'rgb(233, 232, 217)' }}>
              <TableCell
                  key={'all'}
                  align={'all'}
                  class="header_column"
                >
                  <input
                    type="checkbox"
                    onChange={(event) => Unchecked(event)}
                    value='All'
                    name='All'
                    id="All"
                  />
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    class="header_column"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>

              {rowData && rowData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      <TableCell className="cell_data">
                        <input
                          type="checkbox"
                          onChange={(event) => handleDropdownChange(event, row.id)}
                          value={row.id}
                          name={row.id}
                          ref={(element) => { ref.current[index] = element }}
                          id={index}
                        />
                      </TableCell>
                      
                      <TableCell className="cell_data"> {row.vendor_master_id}</TableCell>
                      <TableCell className="cell_data"> {row.vendor_code}</TableCell>
                      <TableCell className="cell_data"> {row.vendor_name}</TableCell>
                      <TableCell className="cell_data"> {row.vendor_site_code}</TableCell>
                      <TableCell className="cell_data"> {row.contact_first_name}</TableCell>
                      <TableCell className="cell_data"> {row.contact_phone_number}</TableCell>
                      <TableCell className="cell_data"> {row.contact_email}</TableCell>
                      <TableCell className="cell_data">
                        <span onClick={e => EditActions({ row })}><ion-icon size="small" name="create-outline" style={{'color':'black'}}></ion-icon></span>
						{row && row.is_active ? 
                              (<>
                                <Button variant="contained" color="primary" type="button" style={{ marginLeft: '1em' }} onClick={e => deactivateEmailId({ row })}>deactivate</Button>
                              </>):(
                                <>
                                <Button variant="contained" color="primary" type="button" style={{ marginLeft: '1em' }} onClick={e => activateEmailId({ row })}>activate</Button>
                                </>
                              )
                         }
                        {/* <span style={{ marginLeft: '1em' }} onClick={e => DeleteActions({ row })}><i class='fa fa-trash-o'></i></span> */}
                      </TableCell>
                    </TableRow>
                  );
                })}

            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10]}
          component="div"
          count={rowData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Emails Add/Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            {/* <Form.Field style={{marginBottom:'0em'}}>
            <label>id</label>
          <input type="text" name="id" value={formValues && formValues.id || ""} disabled={true} /><br /> <br />
            </Form.Field> */}
            <Form.Field style={{marginBottom:'0em'}}><label>Client id</label>
            {formCreate ? <input type="text" disabled={true} name="client_id" value={formValues && formValues.client_id || ""} onChange={e => handleChange(e)} /> :
              <input type="text" required name="client_id" value={formValues && formValues.client_id || ""} onChange={e => handleChange(e)} />}
          
          </Form.Field>
          <Form.Field style={{marginBottom:'0em'}}>
            <label>Client Name</label>
            {formCreate ? <input type="text" disabled={true} name="client_name" value={formValues && formValues.client_name || ""} onChange={e => handleChange(e)}/> :
              <input type="text" required name="client_name" value={formValues && formValues.client_name || ""} onChange={e => handleChange(e)}/> }
          
            </Form.Field>
            <Form.Field style={{marginBottom:'0em'}}>
              <label >Email Id</label>
          <input type="email" required name="email_address" value={formValues && formValues.email_address || ""} onChange={e => handleChange(e)} /><br /><br />
          </Form.Field>
            
        </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {formCreate ? <Button type='submit' onClick={handleSubmit}>Save</Button> :
            <Button type='submit' onClick={handleSubmit}>Update</Button>}
        </Modal.Footer>
      </Modal>

      <Modal
        show={show1}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Emails list</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <p>Are you sure you want to delete?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          
            <Button type='submit' onClick={DeleteEmails1}>Ok</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show3}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title> Send Emails List</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show2}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <p>Email is added successfully !!!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
      <LoaderComponent loaderOpen={loaderOpen} />
      </Grid.Row>
 
      </Grid>
     </div>


      {/* <form onSubmit={handleSubmit} style={{ justifyContent: 'center', marginLeft: '25em', marginTop: '2em' }}>

        <div className="form-inline">

         

          <label className="label">Tenant_id:</label>
          <input type="text" name="tenant_id" value={formValues && formValues.tenant_id || ""} onChange={e => handleChange(e)} /><br /> <br />

          <label className="label">mail Id:</label>
          <input type="text" name="mail_id" value={formValues && formValues.mail_id || ""} onChange={e => handleChange(e)} /><br /><br />

          <br /><br />
        </div>

        <div className="button-section">
          {formCreate ? <Button variant="contained" color="primary" type="submit" style={{ marginLeft: '6em' }}>Create</Button> :
            <Button variant="contained" color="primary" type="submit" style={{ marginLeft: '6em' }}>Save</Button>}
        </div>
      </form> */}

      {/* <div style={{ marginTop: '1em', marginLeft: '1em', marginBottom: '1em' }}>
        <Input
          type="text"
          value={tenantId}
          onChange={e => handleFilterChange(e.target.value)}
          placeholder="Filter by tenant id"
        />
      </div> */}
<div className="report" hidden={hideResultGrid1} style={{marginTop:'1.5em'}}>
			<img src={excelIcon} alt="No Images" style={{ width: '40px', height: '37px' }} className="excel-icon-class" onClick={() => { exportToExcel() }} title="Export" />
		</div>
		<div className="ag-theme-balham report-layer3" style={{width:'100%', height:'75%'}} hidden={hideResultGrid1}>
          <AgGridReact
            columnDefs={gridColumns}
			      rowData={rowData1}
            paginationPageSize={10}
            pagination={true}
            animateRows={true}
            rowSelection={'multiple'}
            groupSelectsChildren={true}        
			      suppressAggAtRootLevel={true}
            suppressRowClickSelection={true}
                        
			>
            </AgGridReact>          
         </div>
     
    </>
  );
}


export default EmailsList;

